module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "layout-breadcrumb"
  }, [_c('Breadcrumb', [_c('BreadcrumbItem', [_c('Icon', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "type": "social-buffer-outline"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("币种管理")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "layout-content"
  }, [_c('div', {
    staticClass: "layout-content-main"
  }, [_c('div', {
    staticClass: "method-wrapper"
  }, [(_vm.isbutShow.selectBut) ? _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [
    [_c('Input', {
      staticStyle: {
        "width": "300px"
      },
      attrs: {
        "placeholder": "币种名称"
      },
      model: {
        value: (_vm.key),
        callback: function($$v) {
          _vm.key = $$v
        },
        expression: "key"
      }
    })], _vm._v(" "), (_vm.isbutShow.selectBut) ? _c('Button', {
      staticClass: "mRight mLeft",
      attrs: {
        "type": "ghost"
      },
      on: {
        "click": function($event) {
          _vm.showKeyList()
        }
      }
    }, [_vm._v("查询")]) : _vm._e()
  ], 2) : _vm._e(), _vm._v(" "), (_vm.isbutShow.addBut) ? _c('Button', {
    staticClass: "mRight",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addAdmin
    }
  }, [_vm._v("新增")]) : _vm._e(), _vm._v(" "), (_vm.isbutShow.updateBut) ? _c('Button', {
    staticClass: "mRight",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.upDateAdmin
    }
  }, [_vm._v("修改")]) : _vm._e(), _vm._v(" "), (_vm.isbutShow.delBut) ? _c('Button', {
    staticClass: "mRight",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.delAdmins
    }
  }, [_vm._v("删除")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "table-wrapper"
  }, [_c('Table', {
    ref: "selection",
    staticStyle: {
      "min-width": "700px"
    },
    attrs: {
      "border": "",
      "columns": _vm.columns,
      "data": _vm.pagerData.data
    },
    on: {
      "on-selection-change": _vm.getSelection
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px",
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('Page', {
    attrs: {
      "total": _vm.pagerData.page.totalCount,
      "show-sizer": "",
      "show-elevator": "",
      "show-total": ""
    },
    on: {
      "on-change": _vm.onChange,
      "on-page-size-change": _vm.sizeChange
    }
  })], 1)])], 1)])]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "",
      "mask-closable": false
    },
    model: {
      value: (_vm.addModel),
      callback: function($$v) {
        _vm.addModel = $$v
      },
      expression: "addModel"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.activeName))])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('Form', {
    ref: "formValidate",
    attrs: {
      "label-position": "left",
      "model": _vm.formValidate,
      "rules": _vm.ruleValidate,
      "label-width": 150
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "币种名称",
      "prop": "currencyName"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入币种名称"
    },
    model: {
      value: (_vm.formValidate.currencyName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "currencyName", $$v)
      },
      expression: "formValidate.currencyName"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "币种英文代码",
      "prop": "currencyEid"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入币种英文代码"
    },
    model: {
      value: (_vm.formValidate.currencyEid),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "currencyEid", $$v)
      },
      expression: "formValidate.currencyEid"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "保留小数位",
      "prop": "decimalDigits"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入保留小数位"
    },
    model: {
      value: (_vm.formValidate.decimalDigits),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "decimalDigits", $$v)
      },
      expression: "formValidate.decimalDigits"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "与本位币的拆算方式",
      "prop": "convertType"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入与本位币的拆算方式"
    },
    model: {
      value: (_vm.formValidate.convertType),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "convertType", $$v)
      },
      expression: "formValidate.convertType"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "long": "",
      "loading": _vm.modal_loading
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("确定")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f2861cd4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/BaseManager/currency.vue
// module id = 944
// module chunks = 1